module.exports = __webpack_public_path__ + "media/images/countrysquared/il-202bd5b537c7f381b44202291e62e0ce.svg";